// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";
import VueTinySlider from "vue-tiny-slider";
import { Api } from "#/api";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    VueTinySlider,
  },
})
export class KennzahlenModule extends ModuleBase {
  private kennzahlenFilter = {};

  public getBackgroundColorFromInstance(instance: object) {
    return instance["section_color"]["color"];
  }

  public mounted() {
    this.loadData();
  }

  @Watch("instance")
  public onInstanceChange() {
    this.loadData();
  }

  public loadData() {
    this.kennzahlenFilter = {};
    this.instance["figures"].slice().forEach((figure) => {
      if (
        figure["value"]["service"] !=
        "Common/Application/Domain/Services/Search/TextInput"
      ) {
        this.getKennzahlenFilter(figure["value"]["filter"]["FILTER"]);
      }
    });
  }

  public async getKennzahlenFilter(id: number) {
    let result = await Api.kpiService.getFilterData(id);
    this.$set(this.kennzahlenFilter, id, result.count);
  }
}
